(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    const initializeEditorialCarousels = (root = document) => {
    const carousels = root.querySelectorAll(
      '.carousel-content--editorial-focus:not([data-editorial-carousel-initialized])'
    );

    carousels.forEach(async (carousel) => {
      carousel.dataset.editorialCarouselInitialized = 'true';
      await customElements.whenDefined('slideshow-component');

      const slideshow = carousel;
      const scroller = carousel.querySelector('slideshow-slides');
      const cards = [...carousel.querySelectorAll('[data-carousel-card]')];

      if (!scroller || cards.length === 0 || typeof slideshow.select !== 'function') return;

      // Keep the editorial carousel arrow-only while preserving links inside each card.
      scroller.addEventListener('pointerdown', (event) => event.stopPropagation(), { capture: true });

      const selectMiddleCard = () => {
        const middleIndex = Math.floor(cards.length / 2);
        slideshow.select(middleIndex, undefined, { animate: false });
      };

      if (!('IntersectionObserver' in window)) {
        selectMiddleCard();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          requestAnimationFrame(selectMiddleCard);
        },
        { rootMargin: '100px' }
      );

      observer.observe(carousel);
    });
  };

  initializeEditorialCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeEditorialCarousels(event.target));
  } catch(e) { console.error(e); }
})();

})();
